import { Injectable } from '@angular/core';
import { configURI } from '../../../shared/apiUrlConfig';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
@Injectable()
export class ParComplaintsRegionstatemapService {
  url = environment.configURI;
  load;

  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
   }

   getRegionStatesTableData(){
    return this.httpClient.get(this.url + '/regions/states')
      .catch(this.userFriendlyMsgs.errorHandler);
  }

  getStatesMappingByRegionId(regionId){
    return this.httpClient.get(this.url + '/regions/states?region_id='+regionId)
      .catch(this.userFriendlyMsgs.errorHandler);
  }

  updateRegionStateMapping(body,regionId){
    return this.httpClient.put(this.url + '/regions/states?region_id='+regionId, body)
      .catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par-complaints-regionstatemap/par-complaints-regionstatemap.service.ts